import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Colors } from 'context';
import { useUser } from 'core';
import fontService, { FontWeight } from 'services/FontService';
import { desktop, tablet } from 'services/ui';
import { getIframeUrlForCourse } from '../../../config/courseIframeConfig';

interface ILessonFinalTestProps {
  courseName: string;
}

export const LessonFinalTest = memo(({ courseName }: ILessonFinalTestProps) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const iframeUrl = getIframeUrlForCourse(courseName);

  if (!iframeUrl) {
    return null;
  }

  const iframeSrc = user?.email
    ? `${iframeUrl}?email=${encodeURIComponent(user.email)}`
    : iframeUrl;

  return (
    <Container>
      <Title>{t('lesson.tabs.finalTest')}</Title>
      <IframeContainer>
        <StyledIframe src={iframeSrc} title={t('lesson.tabs.finalTest')} allowFullScreen />
      </IframeContainer>
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  padding: 20px 0;
`;

const Title = styled.h2`
  margin: 0 0 16px 0;
  color: ${Colors.black};
  ${fontService.getFont({ size: 24, lineHeight: 133, weight: FontWeight.bold })}

  ${tablet} {
    ${fontService.getFont({ size: 28, lineHeight: 143, weight: FontWeight.bold })}
  }

  ${desktop} {
    ${fontService.getFont({ size: 32, lineHeight: 138, weight: FontWeight.bold })}
  }
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 660px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  ${tablet} {
    height: 770px;
    border-radius: 12px;
  }

  ${desktop} {
    height: 880px;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;
